import { Navigate } from "react-router-dom";
import { useSessionCookie } from './UseSessionCookie';
import { COOKIE_NAME_LOGIN_ROLE } from '../../constants/config';

interface RouteAuthorisationProp {
    children: React.ReactNode;
    allowedRoles: string[];
}

const RouteAuthorisation: React.FC<RouteAuthorisationProp> = ({ children, allowedRoles }) => {
    const [loggedInAsRole] = useSessionCookie(COOKIE_NAME_LOGIN_ROLE, undefined);
    if(!loggedInAsRole) return <Navigate to="/login" />
    return allowedRoles.includes(loggedInAsRole || '')? <>{children}</> : <Navigate to="/login" />;
}

export default RouteAuthorisation